// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__10Tge","name":"ConsentHeader_name__f-xMi","birthday":"ConsentHeader_birthday__3PHHM","skeleton":"ConsentHeader_skeleton__2Y5WS"};